export const splict_arr = {
    data() {
        return {
            fileListnum: [],

            num_load: 20,
            perform_load: 0,
            timer_flush: '',
        }
    },
    methods: {
        default_num() {
            this.num_load = 20;
            // this.perform_load = 0;

        },
        // timer_flush_true() {
        //     if (this.perform_load == 1) {
        //         if (this.num_load > this.fileList1.length) {
        //             console.log('come,here', '555555')
        //             this.perform_load = 0

        //             clearInterval(this.timer_flush);
        //             this.timer_flush = null;
        //         } else {


        //             this.timer_flush = setInterval(() => {
        //                 setTimeout(this.loadFile_list(), 0);
        //             }, 1000);
        //         }

        //     } else {
        //         clearInterval(this.timer_flush);
        //         this.timer_flush = null;
        //         this.perform_load = 0

        //     }
        // },

        loadFile_list() {
            console.log(this.num_load, this.size, this.perform_load)
            if (this.num_load <= (this.size)) {
                if (this.num_load < 20 || this.num_load >= this.size) {
                    this.num_load += 20

                } else {
                    this.num_load += (this.size - 20)
                        // this.num_load += 50

                }


                let arr_load = this.fileList1;


                let num = this.num_load;


                this.fileListnum = arr_load.slice(0, num);
                console.log(this.fileListnum.length)

                // console.log(this.fileListnum.length, 'num---------', this.fileList1.length, '表格总数', this.perform_load, '判断', this.totalnums, '总数')
                console.log(this.num_load, this.fileList1.length)
                    // if (this.num_load >= this.fileList1.length) {
                    //     console.log('come,here', )
                    //     this.perform_load = 0
                    //     clearInterval(this.timer_flush);
                    //     this.timer_flush = null;
                    // }
                    // if (this.perform_load != 0) {
                    //     if (this.fileListnum.length < this.fileList1.length) {
                    //         // console.log(this.perform_load)
                    //         this.loadFile_list()
                    //     }
                    // }
            }

        },
        splict_arr(arr, len) {

            let result = [];

            result = arr.slice(0, len)

            // console.log(result, '结果是什么呢')
            setTimeout(() => {
                this.arr_add(arr)
            }, 3)


            return result;
        },
        arr_add(arr) {
            for (let i = 20; i < arr.length; i++) {
                this.fileList1.push(arr[i])
            }
            // this.loading = false;

            // console.log('到这里来了')
            // console.log(this.fileList1)
        }


    }

}